import type { TGetFupSettingsResponse } from "@api";
import type { AdditionalFieldValues } from "@bbj-types/candidate";
import type { IFupBeneficiary } from "@bbj-types/socialApply/fup";
import { Stack, Typography } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import { LabelInfo } from "@styleguide";
interface IVisualizeAdministrativeBeneficiaryProps {
  beneficiaryAdditionalFields: IFupBeneficiary["additionalFields"];
  getFupAdditionalFields: () => TGetFupSettingsResponse;
}

export const VisualizeBeneficiaryFields = ({
  beneficiaryAdditionalFields,
  getFupAdditionalFields,
}: IVisualizeAdministrativeBeneficiaryProps) => {
  const { timeZone } = useI18nContext();
  const additionalFields = getFupAdditionalFields();

  return beneficiaryAdditionalFields && Object.keys(beneficiaryAdditionalFields).length > 0 ? (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="h4" color="primary">
        Bénéficiaire : informations complémentaires
      </Typography>
      <Stack>
        {additionalFields.map((field) => {
          let displayValue = "";
          const fieldValue: AdditionalFieldValues | null | undefined = beneficiaryAdditionalFields[field.value];
          switch (field.type) {
            case "number":
            case "text":
              if (typeof fieldValue === "string" || typeof fieldValue === "number") {
                displayValue = `${fieldValue}`;
              }
              break;
            case "bool":
              displayValue = Boolean(fieldValue?.toString()) === true ? "Oui" : "Non";
              break;
            case "date":
              if (fieldValue instanceof Date) {
                displayValue = fieldValue.toLocaleDateString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  timeZone,
                });
              }
              break;
            case "list":
            case "listMultiple":
              if (field.options && typeof fieldValue === "string") {
                displayValue = field.options.find((v) => v.value === fieldValue)?.label ?? "";
              } else if (field.options && Array.isArray(fieldValue)) {
                const values: string[] = [];
                for (const value of fieldValue) {
                  const fieldOption = field.options.find((v) => v.value === value);
                  if (fieldOption) {
                    values.push(fieldOption.label);
                  }
                }
                displayValue = values.join(", ");
              }
          }
          return <LabelInfo key={field.value} label={field.label} text={displayValue} />;
        })}
      </Stack>
    </Stack>
  ) : null;
};
